module.exports = __webpack_public_path__ + "fonts/font.c5c1c6a.woff2";